<template>
  <li class="login-sns-each apple">
    <a href="#" @click.prevent="loginApple">
      <span class="icon-sns icon-apple"></span>
      <span class="a11y-hidden">Apple ID로 시작하기</span>
    </a>
  </li>
</template>
<script>
  /* eslint-disable */
  import { setLibFile } from '@/common/utils/common'
  import { setReferer } from '@/common/utils/referer'
  import _ from 'lodash'
  export default {
    name: 'BtnApple',
    methods: {
      loginApple () {
        setReferer(_.get(this.$route, 'query.referer', _.get(this.$route, 'fullPath', '')))
        AppleID.auth.init({
          clientId: 'kr.co.captv.pooqV2.member',
          scope: 'email',
          redirectURI: 'https://member.wavve.com/mobile/signup/web/apple',
          state: '',
          usePopup: false //or false defaults to false
        })
        AppleID.auth.signIn()
      }
    },
    created () {
      setLibFile(document, 'script', 'apple-jssdk', '//appleid.cdn-apple.com/appleauth/static/jsapi/appleid/1/ko_KR/appleid.auth.js')
    }
  }
</script>
